module.exports = __webpack_public_path__ + "static/media/triskal_white.18789bd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/triskal_white.svg
// module id = 67
// module chunks = 0